// ---------- A–C ----------
import algorithmicRobotics from "../../assets/trainingPlacement/All_Recuters/Algorithmic Robotics Pvt. Ltd_.jpeg";
import austere from "../../assets/trainingPlacement/All_Recuters/Austere.png";
import bajajFin from "../../assets/trainingPlacement/All_Recuters/Bajaj Fin.jpeg";
import bajajLogo from "../../assets/trainingPlacement/All_Recuters/Bajaj-logo.jpg";
import bereejTechnologies from "../../assets/trainingPlacement/All_Recuters/Bereej Technologies.jpeg";
import cognizant from "../../assets/trainingPlacement/All_Recuters/Cognizant.png";

// ---------- D–F ----------
import download1 from "../../assets/trainingPlacement/All_Recuters/download (1).png";
import download2 from "../../assets/trainingPlacement/All_Recuters/download.png";
import fairmacsShipping from "../../assets/trainingPlacement/All_Recuters/Fairmacs Shipping and Transport Services Pvt. Ltd_.jpeg";
import fedbankFinancial from "../../assets/trainingPlacement/All_Recuters/Fedbank Financial Service Ltd.jpeg";
import fino from "../../assets/trainingPlacement/All_Recuters/Fino.png";
import fujitsu from "../../assets/trainingPlacement/All_Recuters/fujitsu.png";

// ---------- H–K ----------
import heaptrace from "../../assets/trainingPlacement/All_Recuters/Heaptrace.jpg";
import hrutaSolutions from "../../assets/trainingPlacement/All_Recuters/Hruta Solutions.png";
import infosys from "../../assets/trainingPlacement/All_Recuters/Infosys.jpeg";
import intelisyncTechnology from "../../assets/trainingPlacement/All_Recuters/Intelisync Technology Pvt Ltd.png";
import invictosonicsEngineering from "../../assets/trainingPlacement/All_Recuters/Invictosonics Engineering LLP.jpeg";
import jd from "../../assets/trainingPlacement/All_Recuters/JD.png";
// "Just Dial" source file is currently an .html shortcut, not an image — re-save the actual logo file and re-add the import + array entry below
import ksb from "../../assets/trainingPlacement/All_Recuters/KSB.png";

// ---------- N ----------
import nebulaTechnology from "../../assets/trainingPlacement/All_Recuters/Nebula Technology.jpeg";
import netsonSolarSystem from "../../assets/trainingPlacement/All_Recuters/Netson solar system.png";
import nexoraaTechnosolve from "../../assets/trainingPlacement/All_Recuters/Nexoraa Technosolve pvt. ltd_.jpeg";
import nextsquareTechnology from "../../assets/trainingPlacement/All_Recuters/Nextsquare technology.png";
import nityoToolsIndia from "../../assets/trainingPlacement/All_Recuters/Nityo Tools India Pvt. Ltd.png";

// ---------- P–R ----------
import parle from "../../assets/trainingPlacement/All_Recuters/Parle.png";
import portalwiz from "../../assets/trainingPlacement/All_Recuters/Portalwiz.png";
import procucevEnterprise from "../../assets/trainingPlacement/All_Recuters/Procucev Enterprise Solution Pvt. Ltd_.jpeg";
import propmaster from "../../assets/trainingPlacement/All_Recuters/Propmaster.png";
import rohanBuilders from "../../assets/trainingPlacement/All_Recuters/Rohan Builders.jpeg";

// ---------- S–V ----------
import samruddhaSurbhi from "../../assets/trainingPlacement/All_Recuters/Samruddha Surbhi India Producer Company LTD.jpeg";
import teamEngineers from "../../assets/trainingPlacement/All_Recuters/Team Engineers.png";
import techSuryaIt from "../../assets/trainingPlacement/All_Recuters/Tech Surya it solutions.jpeg";
import techsurance from "../../assets/trainingPlacement/All_Recuters/Techsurance Pvt. Ltd.jpeg";
import testYatraSoftware from "../../assets/trainingPlacement/All_Recuters/Test Yatra Software Solutions (I) Pvt. Ltd_.jpeg";
import ups from "../../assets/trainingPlacement/All_Recuters/UPS.png";
import vardhansIntegrated from "../../assets/trainingPlacement/All_Recuters/Vardhans Integrated Facility Management.jpeg";

// ---------- V–W ----------
import voidSpaceSolutions from "../../assets/trainingPlacement/All_Recuters/Void space solutions pvt Ltd.png";
import webMindsIt from "../../assets/trainingPlacement/All_Recuters/Web Minds IT Solutions.png";
import wipro from "../../assets/trainingPlacement/All_Recuters/Wipro.png";

import vishawsya from "../../assets/trainingPlacement/All_Recuters/vishawsya.png";
import europa from "../../assets/trainingPlacement/All_Recuters/europa.png";
import futurism from "../../assets/trainingPlacement/All_Recuters/futurism.png";
import motilal_oswal from "../../assets/trainingPlacement/All_Recuters/motilal_oswal.png";
import digitaledu from "../../assets/trainingPlacement/All_Recuters/digitaledu.png";
import force from "../../assets/trainingPlacement/All_Recuters/force.png";
import eclerx from "../../assets/trainingPlacement/All_Recuters/eclerx.jpg";
import impage from "../../assets/trainingPlacement/All_Recuters/impage.png";
import daccess from "../../assets/trainingPlacement/All_Recuters/daccess.png";
import lokmanya from "../../assets/trainingPlacement/All_Recuters/lokmanya.png";
import jaya_hind from "../../assets/trainingPlacement/All_Recuters/jaya_hind.png";
import thecircle from "../../assets/trainingPlacement/All_Recuters/thecircle.png";
import Portalwiz from "../../assets/trainingPlacement/All_Recuters/Portalwiz.png";

// ---------- Recruiters array ----------
const recruiters = [
  { name: "Algorithmic Robotics Pvt. Ltd", logo: algorithmicRobotics },
  { name: "Austere", logo: austere },
  { name: "Bajaj Fin", logo: bajajFin },
  { name: "Bajaj", logo: bajajLogo },
  { name: "Bereej Technologies", logo: bereejTechnologies },
  { name: "Cognizant", logo: cognizant },
  { name: "Recruiter", logo: download1 }, // TODO: rename source file/company
  { name: "Recruiter", logo: download2 }, // TODO: rename source file/company
  {
    name: "Fairmacs Shipping and Transport Services Pvt. Ltd",
    logo: fairmacsShipping,
  },
  { name: "Fedbank Financial Service Ltd", logo: fedbankFinancial },
  { name: "Fino", logo: fino },
  { name: "Fujitsu", logo: fujitsu },
  { name: "Heaptrace", logo: heaptrace },
  { name: "Hruta Solutions", logo: hrutaSolutions },
  { name: "Infosys", logo: infosys },
  { name: "Intelisync Technology Pvt Ltd", logo: intelisyncTechnology },
  { name: "Invictosonics Engineering LLP", logo: invictosonicsEngineering },
  { name: "JD", logo: jd },
  // { name: "Just Dial", logo: justDial }, // re-add once you re-save the logo as a real image file
  { name: "KSB", logo: ksb },
  { name: "Nebula Technology", logo: nebulaTechnology },
  { name: "Netson Solar System", logo: netsonSolarSystem },
  { name: "Nexoraa Technosolve Pvt. Ltd", logo: nexoraaTechnosolve },
  { name: "Nextsquare Technology", logo: nextsquareTechnology },
  { name: "Nityo Tools India Pvt. Ltd", logo: nityoToolsIndia },
  { name: "Parle", logo: parle },
  { name: "Portalwiz", logo: portalwiz },
  { name: "Procucev Enterprise Solution Pvt. Ltd", logo: procucevEnterprise },
  { name: "Propmaster", logo: propmaster },
  { name: "Rohan Builders", logo: rohanBuilders },
  {
    name: "Samruddha Surbhi India Producer Company LTD",
    logo: samruddhaSurbhi,
  },
  { name: "Team Engineers", logo: teamEngineers },
  { name: "Tech Surya IT Solutions", logo: techSuryaIt },
  { name: "Techsurance Pvt. Ltd", logo: techsurance },
  {
    name: "Test Yatra Software Solutions (I) Pvt. Ltd",
    logo: testYatraSoftware,
  },
  { name: "UPS", logo: ups },
  { name: "Vardhans Integrated Facility Management", logo: vardhansIntegrated },
  { name: "Void Space Solutions Pvt Ltd", logo: voidSpaceSolutions },
  { name: "Web Minds IT Solutions", logo: webMindsIt },
  { name: "Wipro", logo: wipro },

  { name: "vishawsya", logo: vishawsya },
  { name: "europa", logo: europa },
  { name: "futurism", logo: futurism },
  { name: "motilal_oswal", logo: motilal_oswal },
  { name: "digitaledu", logo: digitaledu },
  { name: "force", logo: force },
  { name: "eclerx", logo: eclerx },

  { name: "impage", logo: impage },
  { name: "daccess", logo: daccess },
  { name: "lokmanya", logo: lokmanya },
  { name: "jaya_hind", logo: jaya_hind },
  { name: "thecircle", logo: thecircle },
  { name: "Portalwiz", logo: Portalwiz },
];

export default recruiters;
